// "Anterior" e "Próximo" na tela de leitura — pedido de cliente vindo do
// Roundcube, onde a barra da mensagem tem os dois.
//
// A ORDEM É A DA LISTA que a pessoa estava vendo, não a da conversa nem a da
// data: "próximo" é a linha de baixo, "anterior" a de cima. Na caixa de
// entrada, que vem da mais nova para a mais antiga, isso dá "Próximo" = mais
// antiga — como no Roundcube e no Gmail, onde a seta da direita leva para a
// mais antiga. Seguir outra ordem faria o botão pular para uma mensagem que
// a pessoa não reconhece como "a de baixo".

/** O que basta de uma linha da lista para saber quem está ao lado. */
interface Linha {
  uuid?: string;
}

export interface Vizinhas {
  /** Onde a mensagem aberta está na lista carregada; -1 se não está. */
  posicao: number;
  /** A de cima. */
  anterior?: string;
  /** A de baixo. */
  proxima?: string;
}

/**
 * Acha a linha de cima e a de baixo da mensagem aberta.
 *
 * Mensagem FORA da lista carregada (aberta pela busca, por um link antigo,
 * ou além das páginas já trazidas) devolve posição -1 e nenhuma vizinha. Não
 * se adivinha: um "próximo" que leva a uma mensagem qualquer da pasta é pior
 * que não ter o botão.
 */
export function vizinhas(lista: Linha[], uuid: string): Vizinhas {
  const posicao = uuid ? lista.findIndex((m) => m.uuid === uuid) : -1;
  if (posicao < 0) return { posicao: -1 };
  return {
    posicao,
    anterior: posicao > 0 ? lista[posicao - 1]?.uuid : undefined,
    proxima: lista[posicao + 1]?.uuid,
  };
}
